define(["exports", "./linter-rules/check-charset", "./linter-rules/check-internal-slots", "./linter-rules/check-punctuation", "./linter", "./linter-rules/local-refs-exist", "./linter-rules/no-headingless-sections", "./linter-rules/no-http-props", "./linter-rules/privsec-section"], function (_exports, _checkCharset, _checkInternalSlots, _checkPunctuation, _linter, _localRefsExist, _noHeadinglessSections, _noHttpProps, _privsecSection) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.coreDefaults = _exports.name = void 0;
  _linter = _interopRequireDefault(_linter);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  // @ts-check

  /**
   * Sets the core defaults
   */
  const name = "core/defaults";
  _exports.name = name;

  _linter.default.register(_noHttpProps.rule, _noHeadinglessSections.rule, _checkPunctuation.rule, _localRefsExist.rule, _checkInternalSlots.rule, _checkCharset.rule, _privsecSection.rule);

  const coreDefaults = {
    lint: {
      "no-headingless-sections": true,
      "no-http-props": true,
      "check-punctuation": false,
      "local-refs-exist": true,
      "check-internal-slots": false,
      "check-charset": false,
      "privsec-section": false
    },
    pluralize: false,
    specStatus: "base",
    highlightVars: true,
    addSectionLinks: true
  };
  _exports.coreDefaults = coreDefaults;
});
//# sourceMappingURL=defaults.js.map